export enum CardBackgrounds {
  GREY = 'grey',
  NO_BACKGROUND = 'no-background',
  NO_BORDER = 'no-border',
  SHADOW = 'shadow',
}
